module.exports = __webpack_public_path__ + "img/jQuery.e993f115.svg";